import React from 'react';
import { ScrollableGridContainerContext } from 'contexts/ScrollableGridContainerContext';
import type { ScrollableGridContainerContextValue } from 'contexts/ScrollableGridContainerContext';

interface ScrollableGridContainerContextProviderProps {
  children: React.ReactNode;
  initialValues: ScrollableGridContainerContextValue | undefined;
}

const ScrollableGridContainerContextProvider = ({
  children,
  initialValues,
}: ScrollableGridContainerContextProviderProps) => {
  const contextValue: ScrollableGridContainerContextValue | undefined =
    initialValues;

  //   if (!initialValues) {
  //     return <></>;
  //   }

  return (
    <ScrollableGridContainerContext.Provider value={contextValue}>
      {children}
    </ScrollableGridContainerContext.Provider>
  );
};

export default ScrollableGridContainerContextProvider;
